import React from 'react'
import styled from '@emotion/styled'

import EnsureULSession from 'components/EnsureULSession'
import ErrorBox from './ErrorBox'
import SamplesTable from './SamplesTable'
import SampleFilters from './SampleFilters'
import { useFetchReport, useReportFilters } from './hooks'

const Container = styled.div`
  display: flex;
`

const Centered = styled.div`
  flex: 1;
  margin: auto;
  text-align: center;
`

const AdminPage = () => {
  const { isSaved, filters, saveFilters, resetFilters } = useReportFilters()
  const {
    isPending,
    reportAPIError,
    reportData,
    reportProgress
  } = useFetchReport(filters, isSaved)

  let inner = <Centered>Choose filters on the left.</Centered>
  if (reportAPIError) {
    inner = <ErrorBox error={reportAPIError} />
  } else if (isPending) {
    inner = <Centered>Loading... Found {reportProgress} records...</Centered>
  } else if (reportData && reportData.length) {
    inner = <SamplesTable data={reportData} />
  }

  return (
    <EnsureULSession>
      <Container>
        <SampleFilters
          state={filters}
          save={saveFilters}
          reset={resetFilters}
        />
        {inner}
      </Container>
    </EnsureULSession>
  )
}

export default AdminPage



// WEBPACK FOOTER //
// ./src/routes/admin/index.js